/**
 * All variables from .env files are put into more simple names here for code readability.
 * This is due to the standard format of create-react-app .env properties.
 * @type {string}
 */
export const ENV_NAME = process.env.REACT_APP_ENV_NAME;
export const ENV_FILE_NAME = process.env.REACT_APP_ENV_FILE_NAME;
export const ENV_VERSION = process.env.REACT_APP_VERSION;
export const ENV_TEST_USER = process.env.REACT_APP_TEST_USER;
export const ENV_TEST_PASSWORD = process.env.REACT_APP_TEST_PASSWORD;
export const ENV_TEST_UNPAIDFEE = process.env.REACT_APP_TEST_UNPAIDFEE;
